// File: general-template-7.js
// Import Cumulo
import Cumulo from '../modules/cumulo.js';

class GeneralTemplate7Renderer extends Cumulo {
    onEnter() {
    }
}

// Don`t forget to export your renderer
export default GeneralTemplate7Renderer;